import { Link } from "react-router-dom";
import { Logo } from "@/components/AppShell";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F8F9FA]">
      <div className="flex flex-col px-6 sm:px-12 lg:px-16 py-8">
        <Logo />
        <div className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-10">
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#0A0F1C] tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-500">{footer}</div>}
        </div>
        <p className="text-xs text-slate-400">© 2026 Debro Enterprise Inc. · DEI TradeMatch AI</p>
      </div>
      <div className="hidden lg:block relative overflow-hidden bg-[#0A0F1C]">
        <img
          src="https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Business collaboration"
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0F1C] via-[#0A0F1C]/70 to-transparent" />
        <div className="grain absolute inset-0 opacity-60" />
        <div className="absolute bottom-0 left-0 p-12 max-w-lg">
          <p className="font-heading text-2xl xl:text-3xl font-bold text-white leading-snug">
            Connecting Opportunities. Building Trust. Accelerating Growth.
          </p>
          <p className="mt-4 text-slate-300 text-sm">
            One trusted AI-powered ecosystem for businesses, investors, lenders, suppliers, contractors,
            nonprofits, government agencies and enterprise buyers.
          </p>
        </div>
      </div>
    </div>
  );
}

export function GoogleButton({ label = "Continue with Google" }) {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={handleGoogle}
      data-testid="google-login-button"
      className="w-full h-11 flex items-center justify-center gap-3 rounded-md border border-slate-300 bg-white font-medium text-slate-700 hover:bg-slate-50 transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
      </svg>
      {label}
    </button>
  );
}
